import {
  QUERY_KEYS as SHARED_QUERY_KEYS,
  MUTATION_KEYS as SHARED_MUTATION_KEYS,
} from '@avanta/shared/constants/common';

export const DOMAIN_URL = window.location.origin;
export const MOBILE_MAX_WIDTH = 768;

export const QUERY_KEYS = {
  ...SHARED_QUERY_KEYS,
  FECTH_BAROMETER_HISTORY: 'FECTH_BAROMETER_HISTORY',
  FETCH_DAILY_TRACKING_HISTORY: 'FETCH_DAILY_TRACKING_HISTORY',
  FETCH_ENTERPRISE: 'FETCH_ENTERPRISE',
  FETCH_FILTERED_PSYCHOLOGISTS: 'FETCH_FILTERED_PSYCHOLOGISTS',
  FETCH_PATIENT_APPOINTMENTS: 'FETCH_PATIENT_APPOINTMENTS',
  FETCH_PATIENT_SURVEY_HISTORY: 'FETCH_PATIENT_SURVEY_HISTORY',
  FETCH_PSYCHOLOGIST_AVAILABILITY: 'FETCH_PSYCHOLOGIST_AVAILABILITY',
  FETCH_PSYCHOLOGIST_HISTORICAL_PATIENTS: 'FETCH_PSYCHOLOGIST_HISTORICAL_PATIENTS',
  FETCH_PSYCHOLOGIST_NEXT_SESSIONS: 'FETCH_PSYCHOLOGIST_NEXT_SESSIONS',
  FETCH_PSYCHOLOGIST_RATINGS: 'FETCH_PSYCHOLOGIST_RATINGS',
  FETCH_PSYCHOLOGIST_RECENTS_PATIENTS: 'FETCH_PSYCHOLOGIST_RECENTS_PATIENTS',
  FETCH_PSYCHOLOGIST_RECENTS_PATIENTS_COUNT: 'FETCH_PSYCHOLOGIST_RECENTS_PATIENTS_COUNT',
  FETCH_RECENT_PSYCHOLOGISTS: 'FETCH_RECENT_PSYCHOLOGISTS',
  FETCH_SESSION_PACKS: 'FETCH_SESSION_PACKS',
  FETCH_SPECIALITIES: 'FETCH_SPECIALITIES',
  FETCH_SURVEY_QUESTIONS: 'FETCH_SURVEY_QUESTIONS',
  FETCH_SURVEY_RESPONSES: 'FETCH_SURVEY_RESPONSES',
  FETCH_SURVEYS: 'FETCH_SURVEYS',
  FETCH_WELLBEING_CONTENT: 'FETCH_WELLBEING_CONTENT',
  FETCH_WELLBEING_TAGS: 'FETCH_WELLBEING_TAGS',
};

export const MUTATION_KEYS = {
  ...SHARED_MUTATION_KEYS,
  CREATE_COUPON: 'CREATE_COUPON',
  CREATE_SESSION_PACK: 'CREATE_SESSION_PACK',
  RATE_APPOINTMENT: 'RATE_APPOINTMENT',
  REGISTER_USER: 'REGISTER_USER',
  SAVE_DAILY_TRACKING: 'SAVE_DAILY_TRACKING',
  SEND_REPORT: 'SEND_REPORT',
};

export enum QueryStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  PENDING = 'pending',
  IDLE = 'idle',
}

export const PaginationOrder = {
  RECENT_LAST: 'recent_last',
  RECENT_FIRST: 'recent_first',
} as const;
